<div class="col-12">
  <div fxLayout="column" fxLayoutGap="10px">
    <mat-card style="background-color: #FF5252;color:white;" fxLayout="row" fxLayoutGap="10px" >
      <span fxFlex="100">Session TimeOut </span>
    </mat-card>
  <mat-card >
    <div fxLayoutAlign="start center" fxLayout="column" fxLayoutGap="10px">
      <div class="session-msg"><i class="material-icons-outlined me-1 warn-color">timer</i> Your Session Will Expire In</div>
      <div style="font-size: 20px;"> {{idleState}} </div>
      <div>
       Please click "Continue" to keep working
      </div>
      <div>
          or click "Log Out" to end your session..
      </div>
    </div>
    
  </mat-card>
  <div fxLayout="row" fxLayoutGap="10px" class="mt-2">
    <div fxFlex="50%"></div>
     <button class="ms-0" mat-raised-button style="background-color: green;color:white;" (click)="stay()" >Continue</button>
     <button  mat-raised-button color="warn" (click)="logout()">Log Out</button>
   
    </div>
  </div>
</div>